import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FournisseurService } from '../../../../../../../services/Fournisseur/fournisseur.service';
import {
    getReferenceFromAncestorRoute,
    resolveFournisseurDbIdFromRouteParam
} from '../fournisseur-doc-route.util';

@Component({
    selector: 'app-fr-doc-commande',
    templateUrl: './fr-doc-commande.component.html',
    styleUrls: ['./fr-doc-commande.component.scss']
})
export class FrDocCommandeComponent implements OnInit {
    readonly docType = 'commande-fournisseur' as const;
    fournisseurId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private fournisseurService: FournisseurService
    ) {}

    ngOnInit(): void {
        const ref = getReferenceFromAncestorRoute(this.route);
        resolveFournisseurDbIdFromRouteParam(ref, this.fournisseurService).subscribe(id => {
            this.fournisseurId = id;
        });
    }
}
